// 储存相关
import Setting from '../setting';

//
let getValueCore = key => {
    console.warn('getValue undefined', key);
    return '';
};
function getValue(key) {
    return getValueCore(key);
}
function hookGetValue(f) {
    getValueCore = f;
}

//
let setValueCore = (key, val) => {
    console.warn('setValue undefined', key, val);
};
function setValue(key, val) {
    return setValueCore(key, val);
}
function hookSetValue(f) {
    setValueCore = f;
}

//
let delValueCore = key => {
    console.warn('delValue undefined', key);
};
function delValue(key) {
    return delValueCore(key);
}
function hookDelValue(f) {
    delValueCore = f;
}

// token
function getToken() {
    return getValue(Setting.getStoreToken());
}

function setToken(value) {
    return setValue(Setting.getStoreToken(), value);
}

function delToken() {
    return delValue(Setting.getStoreToken());
}

// uid
function getUid() {
    return getValue(Setting.getStoreUid());
}

function setUid(value) {
    return setValue(Setting.getStoreUid(), value);
}

function delUid() {
    return delValue(Setting.getStoreUid());
}

// openId
function getOpenId() {
    return getValue(Setting.getStoreOpenId());
}

function setOpenId(value) {
    return setValue(Setting.getStoreOpenId(), value);
}

function delOpenId() {
    return delValue(Setting.getStoreOpenId());
}

// staff
function getStaff() {
    const s = getValue(Setting.getStoreStaff());
    if (s && (s === '0' || s === 'false')) {
        return false;
    }
    return !!s;
}

function setStaff(value) {
    return setValue(Setting.getStoreStaff(), value ? '1' : '0');
}

function delStaff() {
    return delValue(Setting.getStoreStaff());
}

// 重定向
function getRedirect() {
    return getValue(Setting.getStoreUid());
}

function setRedirect(value) {
    return setValue(Setting.getStoreUid(), value);
}

function delRedirect() {
    return delValue(Setting.getStoreUid());
}

//
export default {
    //
    getValue,
    setValue,
    delValue,
    hookGetValue,
    hookSetValue,
    hookDelValue,
    //
    getToken,
    setToken,
    delToken,
    //
    getStaff,
    setStaff,
    delStaff,
    //
    getRedirect,
    setRedirect,
    delRedirect,
    //
    getUid,
    setUid,
    delUid,

    getOpenId,
    setOpenId,
    delOpenId,
};
